<div
  #surface
  class="cds-tooltip [ absolute hidden ][ surface-inverse body-small ][ max-w-2xs p-b-3xs p-i-2xs m-0 ][ border-none corner-xs ][ index-overlay ]"
  [attr.popover]="tooltipPosition === 'popover' ? 'manual' : undefined"
>
  {{ plainTooltip }}
</div>
<ng-content></ng-content>
